export function formatMisUpstreamError(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  if (error != null) return String(error)
  return 'неизвестная ошибка'
}
